import ListPopUp from "./listPopUp";

$(window).on("load", () => {
  window.ListPopUp = ListPopUp;
});
